import React from 'react'

function SummaryAnalysis() {
  return (
    <div>
      Summary analysis
    </div>
  )
}

export default SummaryAnalysis
